import type { ReviewDraft } from './types'

export class ReviewOwnershipError extends Error {}

interface ReviewSubmission extends ReviewDraft {
  releaseId: number
  existingReviewId: number | null
  modelId: number | null
  levelId: number | null
}

export const sendReview = async (review: ReviewSubmission) => {
  const isUpdate = review.existingReviewId !== null
  const response = await fetch('/api/reviews', {
    method: isUpdate ? 'PATCH' : 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...(isUpdate ? { id: review.existingReviewId } : { release_id: review.releaseId }),
      score: review.score,
      model_id: review.modelId,
      level_id: review.levelId,
      comments: review.message.trim() || null,
    }),
  })
  if (response.status === 403) {
    throw new ReviewOwnershipError()
  }
  if (!response.ok) {
    throw new Error('Review submission failed')
  }
  const data: { reviewId?: number } = await response.json()
  if (!Number.isInteger(data.reviewId) || !data.reviewId || data.reviewId < 1) {
    throw new Error('Review submission did not return an id')
  }
  return data.reviewId
}
